import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

import './AcknowledgeUpdateModal.less';

class AcknowledgeUpdateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acknowledged: false,
    };

    this.toggleAcknowledgeUpdate = this.toggleAcknowledgeUpdate.bind(this);
    this.handleUpdateSlug = this.handleUpdateSlug.bind(this);
  }

  toggleAcknowledgeUpdate() {
    const { acknowledged } = this.state;
    this.setState({
      acknowledged: !acknowledged,
    });
  }

  handleUpdateSlug() {
    const { updateSlug, hideModalFn } = this.props;
    const { acknowledged } = this.state;
    if (acknowledged) {
      hideModalFn();
      updateSlug();
    }
  }

  render() {
    const { hideModalFn } = this.props;
    const { acknowledged } = this.state;

    return (
      <div className="modal-dialog modal-md container-fluid acknowledge-update-modal__container">
        <h1 className="modal-heading">Are you sure you want to change your URL?</h1>
        <p>Please check the box below to confirm, or hit “Cancel” to keep your existing URL.</p>

        <div className="checkbox col-xs-12">
          <label htmlFor="acknowledge-update__modal-checkbox">
            <input
              type="checkbox"
              name="acknowledge-update__modal-checkbox"
              id="acknowledge-update__modal-checkbox"
              onChange={this.toggleAcknowledgeUpdate}
            />
            <span className="input-override">
              <i className="zolaicion zolaicon-checkmark" />
            </span>
            <span className="input-label">
              I understand that once I update my URL, the old URL I may have shared with guests will
              no longer direct to my website and/or registry. If I have a custom domain, I will have
              to connect it to my new URL.
              <span className="input-label-note">
                Note: It may take up to 10 days for your new URL to show up in search engine results
                like Google.
              </span>
            </span>
          </label>
        </div>

        <div className="cancel-or-confirm pull-right">
          <ButtonV2 variant="secondary" onClick={() => hideModalFn()} className="margin-right">
            Cancel
          </ButtonV2>
          <ButtonV2
            variant={acknowledged ? 'tertiary' : 'primary'}
            disabled={!acknowledged}
            onClick={this.handleUpdateSlug}
          >
            Update URL
          </ButtonV2>
        </div>
      </div>
    );
  }
}

AcknowledgeUpdateModal.propTypes = {
  hideModalFn: PropTypes.func,
  updateSlug: PropTypes.func,
};

export default AcknowledgeUpdateModal;



// WEBPACK FOOTER //
// ./src/pages/settings/url/modal/AcknowledgeUpdateModal.jsx